// Lazy Youtube, adapted from: https://codepen.io/tutsplus/pen/RRVRro

export const lazyLoadYoutube: DrupalBehaviorHooks['attach'] = (context) => {
  context.querySelectorAll<HTMLElement>(".lazy-youtube:not([data-lazy-initialized='1'])").forEach((lazyYoutubeNode) => {
    if (!lazyYoutubeNode.dataset.url) {
      console.error('Lazy YouTube element could not be initialized due to missing url.', lazyYoutubeNode);
      return;
    }
    const url = new URL(lazyYoutubeNode.dataset.url);
    const pathParts = url.pathname.split('/');
    // Convention: embedId is the part after /embed/ in the URL; if not, we gracefully fall back to the first path part
    const embedId = pathParts[pathParts.findIndex((part) => part === 'embed') + 1]!; // eslint-disable-line @typescript-eslint/no-non-null-assertion -- Not null per construction
    const source = `https://i.ytimg.com/vi/${embedId}/sddefault.jpg`;

    const image = new Image();
    image.loading = 'lazy';
    image.src = source;
    lazyYoutubeNode.appendChild(image);

    lazyYoutubeNode.addEventListener('click', (e) => {
      const target = e.currentTarget as HTMLElement | null;
      if (!target) {
        return;
      }
      const iframe = document.createElement('iframe');
      [...target.attributes].forEach((attribute) => {
        iframe.setAttribute(attribute.name, attribute.value);
      });

      url.searchParams.set('autoplay', '1'); // force autoplay
      iframe.src = url.toString();

      target.classList.remove('placeholder');
      target.parentNode?.replaceChild(iframe, target);
    });

    lazyYoutubeNode.dataset.lazyInitialized = '1';
  });
};
